import axios from 'axios'
import { NctsProfileNameResponse } from 'types/NctsProfileNameResponse'
import { apiService, handleApiException, handleResponseData } from '../../../../services/api.service'

export interface NctsExportResponse {
  id: number
  name: string
}

function getAllCustomsProfileForCustomer() {
  return axios
    .get(apiService.getFullApiUrl('/ncts-profile/declaration-profile'))
    .then<NctsProfileNameResponse[]>(handleResponseData)
    .catch(handleApiException)
}

function getAllCustomsProfileByCustomerId(customerId: number) {
  return axios
    .get(apiService.getFullApiUrl(`/ncts-profile/declaration-profile/${customerId}`))
    .then<NctsProfileNameResponse[]>(handleResponseData)
    .catch(handleApiException)
}

function requestTardekProfileAccess() {
  return axios
    .post(apiService.getFullApiUrl('/ncts-profile/request-access'))
    .then(handleResponseData)
    .catch(handleApiException)
}

function getAllProfiles() {
  return axios
    .get(apiService.getFullApiUrl('/ncts-profile/all'))
    .then<NctsExportResponse[]>(handleResponseData)
    .catch(handleApiException)
}

const CustomsProfileService = {
  getAllCustomsProfileForCustomer,
  getAllCustomsProfileByCustomerId,
  requestTardekProfileAccess,
  getAllProfiles,
}

export default CustomsProfileService
